

import { useEffect, useState } from "react";
import url from "../api/url";
import { elToast } from "../functions/Alerta";
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import { ATag } from "../components/ATag";
import { archivos_necesarios } from "../data/datos";


const useModalInfoEmpleado = () => {

    // variables
    const { URL, SERVIDOR } = url()
    const correo = useEmpleadoStore( state => state.correo)
    const [infoEmpleado, setInfoEmpleado] = useState({})
    const [nombreEmpleado, setNombreEmpleado] = useState({})
    const [domicilio, setDomicilio] = useState({})
    const [domicilioFiscal, setDomicilioFiscal] = useState({})
    const [nombreArchivo, setNombreArchivo] = useState( "" )
    const [escolaridadesUsuario, setEscolaridadesUsuario] = useState([])
    const [contactos, setContactos] = useState([])
    const [expDocente, setExpDocente] = useState([])
    const [expSectorProductivo, setExpSectorProductivo] = useState([])
    const [lentes, setLentes] = useState({})
    const [estudiosActuales, setEstudiosActuales] = useState([])
    const [problemas, setProblemas] = useState([])
    const [hijos, setHijos] = useState([])
    const [familiares, setFamiliares] = useState([])
    const [archivosTodos, setArchivosTodos] = useState([])
    const [carpeta, setCarpeta] = useState('')
    const [aceptado, setAceptado] = useState(null)
    const [cargandoAviso, setCargandoAviso] = useState(true)
    const [cuentaBancaria, setCuentaBancaria] = useState({})





    // funciones
    const traerNombres = () => {

        var fd = new FormData()
        fd.append("funcion", "traerNombres")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setNombreEmpleado( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la información', 'error' )
        })
    }


    const traerDatos = () => {

        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ funcion: 'traerDatos', correo })
        })
        .then( res => res.json() )
        .then( e => {
            if ( e ) {
                delete e['ext_docente']
                delete e['exp_sector']
                delete e['fk_empleado']
                delete e['pk_info_empleado']
                setInfoEmpleado( e )
            } else {
				setInfoEmpleado( {} )
			}
        })
        .catch( a => {
            elToast( 'Hay problemas al traer tu información personal', 'error' )
        })
    }


    const traerDomicilio = () => {

        var fd = new FormData()
        fd.append("funcion", "traerDomicilio")
        fd.append("email", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            if ( e ) {
                delete e['pk_domicilio']
                delete e['fk_empleado']
                setDomicilio( e )
			} else {
				setDomicilio( {} )
			}
        })
        .catch( a => {
            elToast( 'Hay un error al traer la información del domicilio', 'error' )
        });
    }

    const traerDomicilioFiscal = () => {

        var fd = new FormData()
        fd.append("funcion", "traerDomicilioFiscal")
        fd.append("email", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            if ( e ) {
                delete e['pk_domicilio_fiscal']
                delete e['fk_empleado']
                setDomicilioFiscal(e)
            } else {
				setDomicilioFiscal({})
			}
        })
        .catch( a => {
            elToast('Hay problemas al traer el domicilio fiscal', 'error')
            // alert("Error al traer los datos de tu domicilio. Puedes revisar tu conexión o iniciar sesión nuevamente.")
        });
    }


    const traerNombreArchivo = () => {

        var fd = new FormData()
        fd.append("funcion", "traerNombreArchivo")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.text() )
        .then( e => {
            setNombreArchivo( e || 'Vacío' )
            if ( e ) {
            }
        })
        .catch( a => {
            elToast('Hay un error al traer el CV', 'error')
        })

    }


    const traerEscolaridad = () => {

        var fd = new FormData()
        fd.append("funcion", "traerEscolaridad")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setEscolaridadesUsuario( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer las escolaridades', 'error')
        })

    }


    const traerContactos = () => {

        var fd = new FormData()
        fd.append("funcion", "traerContactos")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setContactos( e )
        })
        .catch( a => {
            elToast('Hay un error al traer tu lista de contactos.', 'error')
        })

    }


    const traerExpDocente = () => {

        var fd = new FormData()
        fd.append("funcion", "traerExp")
        fd.append("tipo", "docente")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setExpDocente( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la experiencia como docente', 'error' )
        })

    }


    const traerExpTrabajador = () => {

        var fd = new FormData()
        fd.append("funcion", "traerExp")
        fd.append("tipo", "sectorProductivo")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setExpSectorProductivo( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la experiencia como docente', 'error' )
        })

    }


    const traerLentes = () => {

        var fd = new FormData()
        fd.append("funcion", "traerLentes")
        fd.append("email", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setLentes( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la experiencia como docente', 'error' )
        })

    }


    const traerEstudiosActuales = () => {

        var fd = new FormData()
        fd.append("funcion", "traerEstudiosActuales")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setEstudiosActuales( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la experiencia como docente', 'error' )
        })

    }


    const traerProblemas = () => {

        var fd = new FormData()
        fd.append("funcion", "traerProblemas")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setProblemas( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la experiencia como docente', 'error' )
        })

    }


    const traerHijos = () => {

        var fd = new FormData()
        fd.append("funcion", "traerHijos")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setHijos( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la experiencia como docente', 'error' )
        })

    }


    const traerFamiliares = () => {

        var fd = new FormData()
        fd.append("funcion", "traerFamiliares")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setFamiliares( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la experiencia como docente', 'error' )
        })

    }


    function enlaceTitulo( es_titulado, archivo, email ) {

        if (es_titulado && archivo ) {
            var correo_nuevo = email?.split('@')[0];
            archivo = `${SERVIDOR}/archivos/${correo_nuevo}/${archivo}`
            return <ATag link={ archivo } texto='Ver'/>
        }

        if ( es_titulado && archivo == null ) {
            return 'Archivo pendiente'
        }


        if ( es_titulado && [null, '', undefined].includes(archivo) ) {
            return 'Archivo pendiente'
        }

    }


    function traerDocumentosPersona(correo) {

        correo = correo?.split('@')[0]
        setCarpeta( correo )

        var fd = new FormData()
        fd.append("funcion", "traerDocumentosPersona")
        fd.append("correo", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setArchivosTodos( e )
        })
        .catch( a => {
        })
        .finally( e => {

        })
    }

    function tipoArchivo( nombre ) {
        // eslint-disable-next-line
        var a = archivos_necesarios.find( e => e.nombre == nombre )
        return a.descripcion
    }

    function traerAvisoPrivacidad() {
        var fd = new FormData()
        fd.append("funcion", "traerAceptoAviso")
        fd.append("email", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setAceptado( e.aceptado )
        })
        .catch( a => {
            setCargandoAviso(false)
            elToast( 'Hay problemas al acceder al aviso de privacidad', 'error' );
        })
    }

    const traerCuentaBancaria = () => {

        var fd = new FormData()
        fd.append("funcion", "traerCuentaBancaria")
        fd.append("email", correo)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setCuentaBancaria( e )
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la cuenta bancaria', 'error' )
        })

    }

    function traerTodo() {
        traerNombres()
        traerDatos()
        traerDomicilio()
        traerDomicilioFiscal()
        traerNombreArchivo()
        traerEscolaridad()
        traerContactos()
        traerExpDocente()
        traerExpTrabajador()
        traerLentes()
        traerEstudiosActuales()
        traerProblemas()
        traerHijos()
        traerFamiliares()
        traerAvisoPrivacidad()
        traerCuentaBancaria()
    }

    // useEffect
    useEffect(() => {
        if ( correo ) {
            traerTodo()
            traerDocumentosPersona(correo)
        }
        // eslint-disable-next-line
    }, [correo])


    return {
        correo,
        nombreEmpleado, infoEmpleado, domicilio, domicilioFiscal, nombreArchivo, escolaridadesUsuario, contactos,
        expDocente,
        traerTodo,
        expSectorProductivo, lentes, estudiosActuales, problemas, hijos, familiares,
        enlaceTitulo, archivosTodos, tipoArchivo, carpeta, aceptado, cargandoAviso, cuentaBancaria
    }
}

export default useModalInfoEmpleado

